import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Mail, MapPin } from 'lucide-react';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-slate-900 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Tagline */}
          <div className="col-span-1 md:col-span-2">
            <img 
              src="https://customer-assets.emergentagent.com/job_web-refresh-plan/artifacts/6dgaa0wo_Update%20Seli%20Marine%20Logo%20in%20Image%20-%203%20-%20Edited.png" 
              alt="Selimarine" 
              className="h-14 w-auto mb-4"
            />
            <p className="text-gray-400 text-sm mb-4">
              {t('footer.tagline')}
            </p>
            <div className="space-y-3 text-sm text-gray-400">
              <div className="flex items-start space-x-2">
                <MapPin size={16} className="flex-shrink-0 mt-0.5 text-amber-400" />
                <div>
                  <div className="font-semibold text-gray-300">Istanbul, Turkey</div>
                  <div className="text-xs">Pendik / Aeropark</div>
                </div>
              </div>
              <div className="flex items-start space-x-2">
                <MapPin size={16} className="flex-shrink-0 mt-0.5 text-amber-400" />
                <div>
                  <div className="font-semibold text-gray-300">Dakar, Senegal</div>
                  <div className="text-xs">Rue G, Zone B</div>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <Mail size={16} className="text-amber-400" />
                <a href="mailto:info@selimarine.com" className="hover:text-amber-400 transition-colors">
                  info@selimarine.com
                </a>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t('footer.services')}</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>
                <Link to="/services" className="hover:text-amber-400 transition-colors">
                  {t('home.services.marine.title')}
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-amber-400 transition-colors">
                  {t('home.services.pipeline.title')}
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-amber-400 transition-colors">
                  {t('home.services.offshore.title')}
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-amber-400 transition-colors">
                  {t('home.services.energy.title')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t('footer.company')}</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>
                <Link to="/about" className="hover:text-amber-400 transition-colors">
                  {t('nav.about')}
                </Link>
              </li>
              <li>
                <Link to="/projects" className="hover:text-amber-400 transition-colors">
                  {t('nav.projects')}
                </Link>
              </li>
              <li>
                <Link to="/resources" className="hover:text-amber-400 transition-colors">
                  {t('nav.resources')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-amber-400 transition-colors">
                  {t('nav.contact')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-800">
          <p className="text-center text-sm text-gray-400">
            {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;